export const analysisMixin = {
  props: {
    padding: {
      type: Boolean,
      default: true
    },
    tableShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      beforeDateQueryType: 'day',
    }
  },
  methods: {
    resetSort() {
      if (this.sort.prop !== null) {
        const array = ['subtotal','asin','variationAsin','msku','sku'];
        if (array.includes(this.sort.prop)) {
          return;
        }

        if (this.beforeDateQueryType !== this.dateQueryType) {
          this.sort.prop = null;
          this.beforeDateQueryType = this.dateQueryType;
        } else if (this.dateQueryType === 'day') {
          if (this.params.startStatisticsDate > this.sort.prop || this.params.endStatisticsDate < this.sort.prop) {
            this.sort.prop = null;
          }
        } else if (this.dateQueryType === 'week') {
          const [startDate, endDate] = this.sort.prop.split('~');
          if (this.params.startStatisticsDate > startDate || this.params.endStatisticsDate < endDate) {
            this.sort.prop = null;
          }
        } else if (this.dateQueryType === 'month') {
          const [startDate, _] = this.sort.prop.split('~');
          if (this.params.startStatisticsDate > startDate || this.params.endStatisticsDate < startDate) {
            this.sort.prop = null;
          }
        }
      }
    }
  }
};






export const showChartMixin = {
  
  methods: {

    /**
     * data.row
     * data.params
     * data.field
     * data.groupType
     * 
     * @param {*} data 
     */
    handleClickColumn(data){
      // let params =  this.params || this.filter;

      console.log(data)


    }
  }
};

